import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Avatar, Box, Button, Popover, Typography, useTheme } from '@mui/material'
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { useAppSelector, useAppDispatch } from '../../../../store/hooks'
import { logout as logoutAction } from '../../../../store/slices/authSlice'
import { rootPath } from '../../../../logic/paths'
import { revokeAdminSession } from '../../../../logic/apis/auth'
import { teardownSessionWatcher } from '../../../../logic/apis'

function HeaderUserbox() {
  const { user } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  const ref = useRef<any>(null)
  const [isOpen, setOpen] = useState<boolean>(false)

  const handleOpen = (): void => setOpen(true)
  const handleClose = (): void => setOpen(false)

  const logout = async () => {
    try {
      // Best-effort: tell the server to revoke this session before we wipe storage.
      // The helper is short-timeout + swallows errors so this never blocks logout.
      await revokeAdminSession()
    } catch (err) {
      console.error(err)
    } finally {
      teardownSessionWatcher()
      dispatch(logoutAction())
      navigate(rootPath)
    }
  }

  return (
    <>
      <Button
        ref={ref}
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 0.75,
          borderRadius: '10px',
          textTransform: 'none',
          color: 'text.primary',
          border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0'}`,
          transition: 'background 0.2s, border-color 0.2s',
          '&:hover': {
            bgcolor: isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)',
            borderColor: isDark ? 'rgba(255, 255, 255, 0.18)' : '#cbd5e1',
          },
        }}
      >
        <Avatar
          variant="rounded"
          alt={user.name}
          src={user.profilePic}
          sx={{
            width: 34,
            height: 34,
            borderRadius: '8px',
            fontSize: 14,
            fontWeight: 700,
            bgcolor: isDark ? 'rgba(59, 130, 246, 0.15)' : 'rgba(37, 99, 235, 0.1)',
            color: isDark ? '#60a5fa' : '#2563eb',
          }}
        />
        <Box
          sx={{
            textAlign: 'left',
            display: { xs: 'none', md: 'block' },
          }}
        >
          {/* <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 600,
              color: 'text.primary',
              lineHeight: 1.3,
            }}
          >
            {user.name || 'Admin'}
          </Typography> */}
        </Box>
        <ExpandMoreOutlinedIcon
          sx={{
            fontSize: 18,
            color: 'text.secondary',
            display: { xs: 'none', sm: 'block' },
            transition: 'transform 0.2s',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </Button>

      {isOpen && (
        <Popover
          anchorEl={ref.current}
          onClose={handleClose}
          open
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              top: 8,
              borderRadius: '10px',
              minWidth: 200,
              border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
              boxShadow: isDark ? '0 12px 32px rgba(0,0,0,0.6)' : '0 12px 32px rgba(0,0,0,0.15)',
              bgcolor: 'background.paper',
              overflow: 'hidden',
            },
          }}
        >
          {/* <Box
            sx={{
              px: 2,
              py: 1.5,
              borderBottom: `1px solid ${
                isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'
              }`,
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 600,
                color: 'text.primary',
                lineHeight: 1.4,
              }}
            >
              {user.name || 'Admin'}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                color: 'text.secondary',
                lineHeight: 1.4,
              }}
            >
              Administrator
            </Typography>
          </Box> */}
          <Box
            sx={{
              p: 0.75,
              border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'}`,
            }}
          >
            <Button
              onClick={logout}
              fullWidth
              sx={{
                justifyContent: 'flex-start',
                px: 1.5,
                py: 1,
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: 500,
                color: theme.palette.error.main,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: isDark ? 'rgba(239,68,68,0.1)' : 'rgba(239,68,68,0.06)',
                },
              }}
            >
              <LogoutOutlinedIcon sx={{ mr: 1, fontSize: 18 }} />
              Sign out
            </Button>
          </Box>
        </Popover>
      )}
    </>
  )
}

export default HeaderUserbox
